import { render, staticRenderFns } from "./smallModal.vue?vue&type=template&id=7f1c892e&scoped=true&"
import script from "./smallModal.vue?vue&type=script&lang=js&"
export * from "./smallModal.vue?vue&type=script&lang=js&"
import style0 from "./smallModal.vue?vue&type=style&index=0&id=7f1c892e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1c892e",
  null
  
)

export default component.exports